import { render, staticRenderFns } from "./ChampionSeries.vue?vue&type=template&id=4fa39c28&scoped=true&"
import script from "./ChampionSeries.vue?vue&type=script&lang=js&"
export * from "./ChampionSeries.vue?vue&type=script&lang=js&"
import style0 from "./ChampionSeries.vue?vue&type=style&index=0&id=4fa39c28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa39c28",
  null
  
)

export default component.exports